import { Paper } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import { format, parseISO } from "date-fns";

import { humanReadableDateTimeFormat } from "@dzambalaorg/constants";
import { ConfirmationDialog } from "@dzambalaorg/mui-dialog-confirmation";
import type { IRaffleRound } from "@framework/types";
import { Table } from "@dzambalaorg/ui-kit";

export interface IRaffleRoundDialogViewProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  viewItem: IRaffleRound | null;
}

export const RaffleRoundDialogView = (props: IRaffleRoundDialogViewProps) => {
  const { viewItem, onConfirm, open, ...rest } = props;

  if (!open || !viewItem) {
    return null;
  }

  const { roundId, contract, number } = viewItem;

  const { formatMessage } = useIntl();

  const handleConfirm = (): void => {
    onConfirm();
  };

  return (
    <ConfirmationDialog open={open} message="dialogs.view" onConfirm={handleConfirm} {...rest}>
      <Table.Container component={Paper}>
        <Table aria-label="raffle ticket table">
          <Table.Body>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.contract" />
              </Table.Cell>
              <Table.Cell align="right">{contract?.title}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.roundId" />
              </Table.Cell>
              <Table.Cell align="right">{roundId}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.number" />
              </Table.Cell>
              <Table.Cell align="right">{number || formatMessage({ id: "pages.lottery.rounds.wait" })}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.endTimestamp" />
              </Table.Cell>
              <Table.Cell align="right">
                {viewItem.endTimestamp
                  ? format(parseISO(viewItem.endTimestamp), humanReadableDateTimeFormat)
                  : formatMessage({ id: "pages.lottery.rounds.wait" })}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Table.Container>
    </ConfirmationDialog>
  );
};
